import { render, staticRenderFns } from "./Organizers.vue?vue&type=template&id=6b5d8159&"
import script from "./Organizers.vue?vue&type=script&lang=ts&"
export * from "./Organizers.vue?vue&type=script&lang=ts&"
import style0 from "./Organizers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VDataTable,VSkeletonLoader,VTextField})
